import axios from "axios";

export async function postApi({ base = "v1", url, data = {} } = {}) {
  try {
    const result = await axios.post(`/${base}/${url}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return result;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}